// extracted by mini-css-extract-plugin
export default {"gifbox":"index_gifbox_CM0xY","gifmark":"index_gifmark_rx9bs","gifmarkbox":"index_gifmarkbox_rBoDu","gifMask":"index_gifMask_HwIfq"};